const hashString = (str) => {
  let hash = 0;
  let i = 0;
  let chr = null;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return Math.abs(hash).toString(16);
};

export { hashString };
//# sourceMappingURL=hashString.es.js.map
